var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4619 10.553L5.85199 9.2124V19.1186C5.85208 19.2262 5.87337 19.3328 5.91463 19.4321C5.9559 19.5315 6.01634 19.6218 6.0925 19.6979C6.16866 19.7739 6.25905 19.8342 6.35852 19.8753C6.45798 19.9164 6.56456 19.9375 6.67218 19.9374H19.8034C19.9112 19.9377 20.0179 19.9167 20.1175 19.8757C20.2171 19.8347 20.3077 19.7744 20.384 19.6983C20.4603 19.6223 20.5209 19.5319 20.5622 19.4325C20.6036 19.333 20.6249 19.2263 20.625 19.1186V15.4687L13.4619 10.553Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4619 2.0625H6.67218C6.56456 2.06241 6.45798 2.08352 6.35852 2.12462C6.25905 2.16572 6.16866 2.22601 6.0925 2.30204C6.01634 2.37807 5.9559 2.46836 5.91463 2.56776C5.87337 2.66715 5.85208 2.77369 5.85199 2.88131V6.53125L13.4619 11L17.4914 12.3406L20.625 11V6.53125L13.4619 2.0625Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85199 6.53125H13.4619V11H5.85199V6.53125Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M11.2984 5.63745H5.85199V16.8093H11.2984C11.5154 16.8082 11.7232 16.7217 11.8769 16.5684C12.0305 16.4152 12.1176 16.2075 12.1192 15.9905V6.45626C12.1176 6.23925 12.0305 6.03161 11.8769 5.87834C11.7232 5.72508 11.5154 5.63853 11.2984 5.63745Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.8508 6.08447H5.85199V17.2563H10.8508C11.0678 17.2553 11.2757 17.1687 11.4293 17.0155C11.583 16.8622 11.6701 16.6546 11.6717 16.4375V6.90329C11.6701 6.68627 11.583 6.47863 11.4293 6.32537C11.2757 6.1721 11.0678 6.08555 10.8508 6.08447Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.8508 6.08447H5.85199V16.3626H10.8508C11.0678 16.3615 11.2757 16.275 11.4293 16.1217C11.583 15.9684 11.6701 15.7608 11.6717 15.5438V6.90329C11.6701 6.68627 11.583 6.47863 11.4293 6.32537C11.2757 6.1721 11.0678 6.08555 10.8508 6.08447Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.4032 6.08447H5.85199V16.3626H10.4032C10.6203 16.3615 10.8281 16.275 10.9818 16.1217C11.1354 15.9684 11.2225 15.7608 11.2241 15.5438V6.90329C11.2225 6.68627 11.1354 6.47863 10.9818 6.32537C10.8281 6.1721 10.6203 6.08555 10.4032 6.08447Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19587 6.08447H10.4032C10.6207 6.08429 10.8292 6.17043 10.9832 6.32397C11.1371 6.47751 11.2238 6.68588 11.2241 6.90329V15.0969C11.2238 15.3143 11.1371 15.5227 10.9832 15.6762C10.8292 15.8298 10.6207 15.9159 10.4032 15.9157H2.19587C2.0882 15.9159 1.98154 15.8949 1.882 15.8538C1.78246 15.8127 1.69199 15.7525 1.61576 15.6764C1.53952 15.6004 1.47902 15.5101 1.43771 15.4106C1.3964 15.3112 1.37509 15.2046 1.375 15.0969V6.90329C1.37509 6.79561 1.3964 6.68901 1.43771 6.58957C1.47902 6.49013 1.53952 6.39981 1.61576 6.32377C1.69199 6.24773 1.78246 6.18745 1.882 6.14639C1.98154 6.10533 2.0882 6.08429 2.19587 6.08447Z",
    fill: "url(#paint0_linear_3524_2285)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91876 13.6628L5.64508 10.9925L4.06382 8.3374H5.33364L6.19645 10.0376C6.2762 10.1985 6.33395 10.3181 6.36008 10.3978H6.37176C6.42814 10.2686 6.48795 10.1442 6.55051 10.0225L7.47314 8.34015H8.64189L7.02008 10.9802L8.68314 13.6648H7.43945L6.44258 11.801C6.39629 11.7209 6.35696 11.6369 6.32501 11.5501H6.30851C6.27944 11.6347 6.24069 11.7157 6.19301 11.7914L5.16657 13.6628H3.91876Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8041 2.0625H13.4619V6.53125H20.625V2.88131C20.6249 2.77364 20.6036 2.66703 20.5623 2.5676C20.521 2.46816 20.4605 2.37784 20.3842 2.3018C20.308 2.22575 20.2175 2.16548 20.118 2.12442C20.0184 2.08336 19.9118 2.06232 19.8041 2.0625Z",
    fill: "#33C481"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4619 11H20.625V15.4688H13.4619V11Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3524_2285",
    x1: 3.08962,
    y1: 5.44097,
    x2: 9.5095,
    y2: 16.5592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/Excel_Icon.6f55c2071828d547dff84021e2007462.svg";
export { ForwardRef as ReactComponent };